<template>
  <div class="bg-white" v-loading="isLoading">
    <el-row type="flex" justify="end" class="pt-1"> </el-row>
    <el-table :data="list.data">
      <el-table-column label="Actions" width="110">
        <template slot-scope="scope">
          <router-link
            class="el-button el-button--primary el-button--small is-circle"
            :to="{ name: 'stockout_info', params: { id: scope.row.id } }"
            title="View stockout information"
            ><i class="el-icon-folder-opened"></i>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column label="Job Order Number" prop="job_order_no">
      </el-table-column>
      <el-table-column label="Date Created" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at | dateFormat }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="!isLoading"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="list.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(list.paging.cur_page)"
      @current-change="fetch"
    ></el-pagination>
  </div>
</template>

<script>
import Part from "@/models/Part";
export default {
  name: "StockoutList",

  data() {
    return {
      isLoading: false,
      list: { data: [], paging: {} },
      pager: {
        page: 1,
        limit: 25,
        search: ""
      }
    };
  },
  methods: {
    fetch(page) {
      this.pager.page = page;
      var params = { ...this.pager };
      // if (!this.pager.search) delete params.search;
      Part.stockouts(params).then(resp => {
        this.list = resp;
      });
    }
  },
  mounted() {
    this.fetch(1);
  }
};
</script>

<style lang="css" scoped></style>
